"use client";

import ShareIcon from "@/assets/icons/tsx/ShareIcon";
import { useEffect, useRef, useState } from "react";
import MotionProvider from "@/components/motion/MotionProvider";
import { kodeMonoBold } from "@/lib/kodeMonoBold";
import { AnimatePresence, m } from "@/lib/motion";
import { FaXTwitter, PiTelegramLogo } from "@/components/icons";

export default function ShareButton(): React.ReactElement {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const shareUrl = typeof window !== "undefined" ? window.location.href : "";

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className={`${kodeMonoBold.variable} border border-white/10 bg-white/10 px-3 sm:px-5 py-2.5 flex gap-x-2 items-center text-[13px] font-kode-mono-bold leading-4 text-white uppercase hover:bg-white/25 transition-all duration-300 cursor-pointer`}
      >
        <span className="max-sm:hidden">share</span>
        <ShareIcon />
      </button>
      <MotionProvider>
      <AnimatePresence>
        {open && (
          <m.div
            initial={{ opacity: 0, y: -8, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -8, scale: 0.96 }}
            transition={{ duration: 0.18, ease: "easeOut" }}
            className="absolute right-0 mt-2 min-w-50 bg-black border border-white/10 shadow-lg overflow-hidden z-50"
          >
            <a
              href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex gap-x-2 items-center px-4 py-2 text-sm text-white hover:bg-white/10 transition"
            >
              <FaXTwitter />
              Share on X
            </a>
            <a
              href={`https://t.me/share/url?url=${encodeURIComponent(shareUrl)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex gap-x-2 items-center px-4 py-2 text-sm text-white hover:bg-white/10 transition"
            >
              <PiTelegramLogo />
              Share on Telegram
            </a>
          </m.div>
        )}
      </AnimatePresence>
      </MotionProvider>
    </div>
  );
}
